import React from 'react';
import { NotificationManager } from 'react-notifications';
import { RequestNewVersion } from '../../../classes/RequestNewVersion';
import { getTimeTranscurred } from '../../../../utils/date';
import _ from 'lodash';
import { getLabelFromDictionary } from '../../../../config/dictionary';
import { Button } from 'react-bootstrap';
import {
  ExpedientNumberLink,
  isLogicalDeleted,
} from '../../../helper_components/logical_deleted_expedient/LogicalDeletedExpedient';

export const initColumns = [
  {
    dataField: 'expedient_number_link',
    text: `No. ${getLabelFromDictionary('global', 'lowerMainName')}`,
    sort: true,
    style: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    dataField: 'responsible',
    text: 'Responsable',
    sort: true,
    style: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    dataField: 'time_elapsed',
    text: `Tiempo de recepción del ${getLabelFromDictionary('global', 'lowerMainName')}`,
    sort: true,
    style: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    dataField: 'time_indicator',
    text: 'Indicador',
    sort: true,
    style: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    dataField: 'visibility',
    text: 'Visibilidad',
    sort: true,
    style: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
];

export const getExpedientsList = async (
  setExpedients,
  setTotalExpedients,
  page,
  sizePerPage,
  setShowExpiration,
  setDocumentsData,
  setShowVisibility,
  setDocumentsDataNoView
) => {
  const request = new RequestNewVersion(
    `${process.env.REACT_APP_URL_API_LARAVEL}/electronic_expedients/find_by_court/${sizePerPage}?page=${page}`,
    'get',
    null,
    {}
  );

  const responseMyExpedients = _.defaultTo(await request.executeRequest(), {});

  if (responseMyExpedients.code !== 200) {
    NotificationManager.error(
      `Algo sucedió y no fue posible traer los ${getLabelFromDictionary('global', 'lowerMainName')}, inténtalo nuevamente`
    );
  } else {
    if (
      responseMyExpedients.response.error &&
      responseMyExpedients.response.message &&
      typeof responseMyExpedients.response.message === 'string'
    ) {
      NotificationManager.error(responseMyExpedients.response.message);
    } else {
      const formatedExpedients = formatExpedients(
        responseMyExpedients.response.electronicExpedients,
        setShowExpiration,
        setDocumentsData,
        setShowVisibility,
        setDocumentsDataNoView
      );
      setExpedients(formatedExpedients);
      setTotalExpedients(responseMyExpedients.response.total);
    }
  }
};

const formatExpedients = (
  expedients,
  setShowModal,
  setDocumentsData,
  setShowModalPermissions,
  setDocumentsDataNoView
) => {
  return expedients.map((expedient, index) => {
    return {
      id: expedient.id,
      logical_deleted: isLogicalDeleted(expedient),
      expedient_number_link: expedientNumberLink(
        expedient.expedient_number,
        expedient.id,
        isLogicalDeleted(expedient)
      ),
      responsible: expedient.responsible,
      time_elapsed: getTimeTranscurred(new Date(expedient.updated_at.replace(/-/g, '/'))),
      time_indicator: timeIndicator(
        expedient.warning_flag,
        expedient.expirations,
        setShowModal,
        setDocumentsData
      ),
      visibility: visibility(setShowModalPermissions, expedient.no_viewers, setDocumentsDataNoView),
    };
  });
};

const expedientNumberLink = (expedientNumber, expedientId, logicalDeleted = false) => {
  return (
    <ExpedientNumberLink
      logicalDeleted={logicalDeleted}
      to={{
        pathname: `/expedient_details/${expedientId}`,
        state: {
          labelPath: 'Mis expedientes',
          prevPath: window.location.pathname,
        },
      }}
    >
      {expedientNumber}
    </ExpedientNumberLink>
  );
};

const timeIndicator = (indicator, expirations, setShowModal, setDocumentsData) => {
  return (
    <a
      onClick={() => {
        setDocumentsData(expirations);
        setShowModal(true);
      }}
    >
      <span className={'dot-' + indicator} />
    </a>
  );
};

const visibility = (setShowModalPermissions, no_viewers, setDocumentsDataNoView) => {
  return (
    <a
      onClick={() => {
        setDocumentsDataNoView(no_viewers);
        setShowModalPermissions(true);
      }}
    >
      <i className="fas fa-eye" />
    </a>
  );
};
